<template>
  <footer>
    <noindex>
    <div class="container footer-container">
      <div class="capture">© 2017-2018 kodobi.ru</div>
      <div class="footer-menu">
        <a class="footer-item" :href="siteUrl('about')" rel="nofollow">{{ $t('О нас') }}</a>
        <a class="footer-item" :href="siteUrl('vacancy')" rel="nofollow">{{ $t('Вакансии') }}</a>
        <a class="footer-item" :href="siteUrl('contacts')" rel="nofollow">{{ $t('Контакты') }}</a>
        <a class="footer-item" :href="siteUrl('user-agreement')" rel="nofollow">{{ $t('Пользовательское соглашение') }}</a>
      </div>
    </div>
    </noindex>
    <a class="hidden-xs hidden-sm store-link" href="https://chrome.google.com/webstore/detail/kodobiru/mjfnijmemjilopepdgnakgghiboempgf" target="_blank">
      <img src="../../../img/ChromeWebStore.png" width="200" height="56" alt="Установить расширение">
    </a>
  </footer>
</template>

<script>
export default {
  name: 'app-footer',

  data() {
    return {};
  },

  methods: {}
};
</script>

<style scoped>
footer {
  display: flex;
  align-items: center;
  min-height: 65px;
  margin-top: auto;
  padding: 10px 0;
  font-size: 14px;
}

.footer-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.footer-container div {
  margin: 10px 0;
}

.footer-container .capture {
  margin: 10px 35px 10px 0;
}

.footer-item {
  margin: 0 0 0 35px;
  text-decoration: underline;
}

.store-link {
  margin: 0 0 0 25px;
}

.store-link img {
  display: inline-block;
}

@media (max-width: 767px) {
  .footer-item {
    display: inline-block;
    margin: 0 25px 0 0;
  }

  .footer-item:last-child {
    margin: 0;
  }
}
</style>
